export default "__VITE_ASSET__AyqbJmln__"